module.exports = __webpack_public_path__ + "csv_templates/child-72f92553ed836242189da1bf18502ddc.csv";